import { useRef } from "react";
import { mediaElementAtom } from "../../atoms/audioAtom";
import { useAtomValue } from "jotai";
import { DEFAULT_TIME } from "./waveformHooks";
import { convertWaveformDurationToReadableTime } from "./waveformUtils";

export const useGetCurrentSeekTime = (isSameProject: boolean) => {
  const audioElement = useAtomValue(mediaElementAtom);
  const currentSeekTime = useRef<string>(DEFAULT_TIME);
  if (audioElement === null) return;
  if (!isSameProject) {
    currentSeekTime.current = DEFAULT_TIME;
  } else {
    currentSeekTime.current = convertWaveformDurationToReadableTime(
      audioElement.currentTime,
    );
  }
  return currentSeekTime;
};
